import type { UserResource } from "@clerk/types";

/**
 * Triggers the PartnerStack (GrowSumo) signup event if the script is available.
 * @param user The Clerk user object
 */
export function triggerPartnerStackSignup(user: UserResource) {
  // Beyond checking if the window, growsumo, and user are defined, we also check if the xid or partner_key is defined.
  // This is in response to the console error that occurs when growsumo.createSignup() is called without the xid or partner_key.
  // Where the endpoint returns a 400 error with the message "Request missing at least one of xid, partner_key."
  if (
    typeof window !== "undefined" &&
    window.growsumo &&
    user &&
    (window.growsumo.data.xid || window.growsumo.data.partner_key)
  ) {
    window.growsumo.data.name = user.fullName || "";
    window.growsumo.data.email = user.primaryEmailAddress?.emailAddress || "";
    window.growsumo.data.customer_key =
      user.primaryEmailAddress?.emailAddress || "";
    window.growsumo.createSignup();
  }
}
